import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { FormHelperText } from '@mui/material';
import './SelectBox.scss';

export default function SelectBox(props) {
  const {
    sx,
    formControlSx,
    label,
    options = [],
    onChange,
    value = '',
    error = false,
    helperText = '',
    formatOptionLabel,
    menuMaxHeight = 300,
  } = props;

  const [internalValue, setInternalValue] = React.useState('');
  const getOptionLabel = (option) => (formatOptionLabel ? formatOptionLabel(option) : option);

  const handleChange = (event) => {
    if (onChange) onChange(event.target.value);
    else setInternalValue(event.target.value);
  };

  return (
    <div style={sx} id='selector'>
      <FormControl fullWidth error={error} sx={formControlSx}>
        <InputLabel id='demo-simple-select-label'>{label}</InputLabel>
        <Select
          labelId='demo-simple-select-label'
          id='demo-simple-select'
          value={onChange ? value : internalValue}
          label={label}
          onChange={handleChange}
          className='demo-simple-select'
          size='small'
          MenuProps={{
            disableScrollLock: true,
            PaperProps: {
              sx: {
                maxHeight: menuMaxHeight,
                overflowY: 'auto !important',
                '&::-webkit-scrollbar': { width: 8 },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: 'rgba(0,0,0,0.3)',
                  borderRadius: 4,
                },
              },
            },
          }}
        >
          {options.map((el, i) => (
            <MenuItem key={i} value={el} className='menu-item'>
              {getOptionLabel(el)}
            </MenuItem>
          ))}
        </Select>
        {error && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    </div>
  );
}
